export default url => {
  return url.test(window.location.href);
};
